
// import { pdMixin } from '@/mixin/pd/pdMixin'
import { convertCdnResizeUrl, errorPrfImg, convertPrfResizeUrl, isNotEmpty, unescape } from '@/utils'
import { getCapturedImageUrl, getResizedImgUrl } from '~/scriptData/common/interM2'
import CommonImage from '~/components/common/CommonImage.vue'
import CommonVideo from '~/components/common/CommonVideo.vue'
export default {
  components: {
    CommonVideo,
    CommonImage
  },
  // mixins: [pdMixin],
  props: {
    unitType: { // component 노출 타입
      type: String,
      default: ''
    },
    item: { // 리뷰 아이템
      type: Object,
      default () { return {} }
    }
  },
  data () {
    return {
      revwStmtPopover: false, // 리뷰신고 popover
      reviewImgStatus: 'small', // 리뷰 이미지 스와이퍼
      swiperReviewTop: {
        zoom: true,
        slidesPerView: 1,
        lazy: true,
        observer: true,
        observeParents: true,
        simulateTouch: true,
        // 23.08.21 bullet 데이터 추가
        pagination: {
          el: '.swiper-pagination',
          clickable: false,
          type: 'fraction',
          renderFraction (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span>' + '<span> / </span>' + '<span class="' + totalClass + '"></span>'
          }
        },
        // 23.08.16 스와이퍼 버튼 셀렉터 변경
        navigation: {
          nextEl: '.review-slide .swiper-button-next',
          prevEl: '.review-slide .swiper-button-prev'
        }
      },
      // 썸네일 스와이퍼
      swiperReviewThumb: {
        slidesPerView: 'auto',
        spaceBetween: 16,
        lazy: true,
        observer: true,
        observeParents: true,
        slideToClickedSlide: true,
        simulateTouch: true,
        // 23.08.16 스와이퍼 버튼 추가
        navigation: {
          nextEl: '.review-thumb .swiper-button-next',
          prevEl: '.review-thumb .swiper-button-prev'
        }
      },
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.videoLazyCtrl() // 23.10.16 video(자동재생) 정지/재생 기능
    })
  },
  methods: {
    getCapturedImageUrl,
    getResizedImgUrl,
    slideImgGrp (e) { // 리뷰 이미지 슬라이드(mo 와 통일)
      this.reviewImgStatus = 'large'
      setTimeout(() => {
        this.$refs.reviewPhotoGrpLg.swiper.slideTo(e.subIndex, 0)
      }, 0)
    },
    convertCdnResizeUrl (url, resize) {
      return convertCdnResizeUrl(url, resize)
    },
    errorPrfImg (e) {
      return errorPrfImg(e)
    },
    convertPrfResizeUrl (url, resize) {
      return convertPrfResizeUrl(url, resize)
    },
    isNotEmpty (obj) {
      return isNotEmpty(obj)
    },
    unescape (str) {
      return unescape(str)
    },

    // 23.10.16 동영상 관련 함수 정의
    videoLazyCtrl () { // video(자동재생) 정지/재생 기능
      const lazyVideo = this.isNotEmpty(this.$refs.lazyVideo) ? this.$refs.lazyVideo : []

      // 옵션 (video 선택자가 viewprot에 교차되는 옵션 설정)
      const options = {
        root: null,
        rootMargin: '-250px -40px -250px -40px',
        threshold: [0.4]
      }

      // 콜백함수
      const onSensor = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting === false) { // 동영상이 화면에서 벗어날 때
            // data id값으로 해당 컴포넌트 접근하여 작업 (퍼블 예시)
            if (entry.target.closest('.video-wrap') === null) { return false } // video 선택자 못 가져올 경우 return
            const valId = entry.target.closest('.video-wrap').getAttributeNode('id').value.slice(6)
            this.stop(valId)

            // 스와이프 실행시 영상 초기화(단말기 테스트시 slide 체크 못하면 swiper event로 대체)
            if (entry.target.closest('.swiper-slide').classList.contains('swiper-slide-active') === false) {
              this.reload(valId)
            }
          } else if (entry.isIntersecting === true) { // 동영상이 화면에 진입할 때
            // data id값으로 해당 컴포넌트 접근하여 작업 (퍼블 예시)
            if (entry.target.closest('.video-wrap') === null) { return false } // video 선택자 못 가져올 경우 return
            const valId = entry.target.closest('.video-wrap').getAttributeNode('id').value.slice(6)
            this.play(valId)
          }
        })
      }

      // 인스턴스
      const videoIob = new IntersectionObserver(onSensor, options) // 메뉴(상세, 전시, 콘텐츠커머스)별로 관리가 필요할 시 인스턴스 추가

      // 실행
      lazyVideo.forEach((video) => {
        videoIob.observe(video)
      })
    },

    play (val) { // 재생
      if (Array.isArray(this.$refs[`video${val}`])) { // data type 배열
        console.log('재생', 'component:', this.$refs[`video${val}`])
        this.$refs[`video${val}`][0]?.player.play()
      } else {
        console.log('재생', 'component:', this.$refs[`video${val}`])
        this.$refs[`video${val}`]?.player.play()
      }
    },
    stop (val) { // 정지
      if (Array.isArray(this.$refs[`video${val}`])) { // data type 배열
        console.log('정지', 'component:', this.$refs[`video${val}`][0])
        this.$refs[`video${val}`][0]?.player.pause()
      } else {
        console.log('정지', 'component:', this.$refs[`video${val}`])
        this.$refs[`video${val}`]?.player.pause()
      }
    },
    muted (val) { // 음소거
      if (val.ref !== undefined) {
        if (Array.isArray(this.$refs[val.ref])) {
          console.log('음소거', 'component:', this.$refs[val.ref][0].$refs[`video${val.id}`])
          this.$refs[val.ref][0].$refs[`video${val.id}`]?.player.muted(val.checked)
        } else if (Array.isArray(this.$refs[val.ref].$refs[`video${val.id}`])) {
          console.log('음소거', 'component:', this.$refs[val.ref].$refs[`video${val.id}`][0])
          this.$refs[val.ref].$refs[`video${val.id}`][0]?.player.muted(val.checked)
        } else {
          console.log('음소거', 'component:', this.$refs[val.ref].$refs[`video${val.id}`])
          this.$refs[val.ref].$refs[`video${val.id}`]?.player.muted(val.checked)
        }
      } else if (Array.isArray(this.$refs[`video${val.id}`])) {
        console.log('음소거', 'component:', this.$refs[`video${val.id}`][0])
        this.$refs[`video${val.id}`][0]?.player.muted(val.checked)
      } else {
        console.log('음소거', 'component:', this.$refs[`video${val.id}`])
        this.$refs[`video${val.id}`]?.player.muted(val.checked)
      }
    },
    fullScreen (val) { // 전체보기
      if (val.ref !== undefined) {
        console.log('전체보기', 'component:', this.$refs[val.ref].$refs[`video${val.id}`][0])
        this.$refs[val.ref].$refs[`video${val.id}`][0]?.player.requestFullscreen()
      } else if (Array.isArray(this.$refs[`video${val.id}`])) {
        console.log('전체보기', 'component:', this.$refs[`video${val.id}`][0])
        this.$refs[`video${val.id}`][0]?.player.requestFullscreen()
      } else {
        console.log('전체보기', 'component:', this.$refs[`video${val.id}`])
        this.$refs[`video${val.id}`]?.player.requestFullscreen()
      }
    },
    reload (val) { // 영상 리로드 (스와이프에서 사용)
      this.$nextTick(() => {
        this.$refs[`video${val}`]?.[0]?.player?.load()
      })
    },

    // 리뷰 신고 팝업
    openLayerRevwStmt (revwMngNo) {
      this.$emit('openLayerRevwStmt', { name: 'revwStmt', data: { revwMngNo } })
    },

    // 리뷰 상세 팝업
    openLayerRevwDtl (revwMngNo) {
      this.$emit('openLayerRevwDtl', { name: 'revwDtl', data: { revwMngNo } })
    },

  }

}
